import React, { useRef, useState } from 'react';
// import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { divide, multiply, subtract } from 'mathjs';
import { useAuthUser } from 'react-auth-kit';
import { QRCodeComponent } from './qr_code_component.js';
import { BenchmarksGraphComponent} from './benchmarks_graph_component.js';
// GRAPHQL QUERY
import { 
    SaveUserPTC
} from './users_graphql.js';

// DOCS: https://www.apollographql.com/docs/react/get-started/
// Import everything needed to use the `useQuery` hook
import { useMutation } from '@apollo/client';



export function BenchmarksCardComponent(props) {
    console.log("Benchmark props: ", props)
    const targetRef2 = useRef(null);

    const auth = useAuthUser();
    // PTCs are loaded oldest to latest, so we can run a compare against the previous benchmark for percentage gained. Then reverse the order for displaying.
    const [Benchmarks, setBenchmarks] = useState([ ...props.PTCs ]);
    const [BaseState, setBaseState] = useState({ 
        loading: false,
        show_qr_reader: false 
    });
    const [SelectedPTC, setSelectedPTC] = useState({ user_PTC_ID: 0 });
    const [save_PTC] = useMutation(SaveUserPTC);

    // Handle QR Code Result
    async function handleQRCode(code) {
        setBaseState({ ...BaseState, show_qr_reader: false })
        let QR_code = {};

        // Logic for parsing the QR Code
        let SplitArray = code.split(',');                    
        QR_code.user_PTC_ID = 0;
        QR_code.creator_ID = parseInt(auth().User.user_ID);
        QR_code.user_ID = parseInt(props.SelectedUser.user_ID);
        QR_code.date_performed = dayjs().format();
        QR_code.R_max_supra = SplitArray[2];
        QR_code.L_max_supra = SplitArray[3];
        QR_code.R_max_infra = SplitArray[5];
        QR_code.L_max_infra = SplitArray[6];
        QR_code.R_max_teres = SplitArray[8];
        QR_code.L_max_teres = SplitArray[9];
        QR_code.R_max_subscap = SplitArray[11];
        QR_code.L_max_subscap = SplitArray[12];
        QR_code.R_max_house = SplitArray[14];
        QR_code.L_max_house = SplitArray[15];

        const result = await save_PTC({ variables: { input: { ...QR_code, user_PTC_ID: 0 } }});
        if ( result.data && result.data.usersPTCSave && result.data.usersPTCSave.user_PTC_ID > 0 ) {

            // Add this QR Code to the Benchmarks
            let TempBenchmarks = [...Benchmarks];
            TempBenchmarks.push(result.data.usersPTCSave);

            setBenchmarks([...TempBenchmarks]);
        }
    }

    function handleCloseGraph() {
        props.setAction('');
        setTimeout(() => props.playerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 200);
    }

    // NuShoulder Workout Entries card
    return (
        <div className="card h-100" ref={targetRef2}>
            <div className="card-header h4 border border-secondary">
                <div className="clearfix">
                    <span className={`float-start mt-1 ${!props.card_open && 'text-muted'}`} onClick={() => props.setCardOpenBenchmarks(!props.card_open)}>
                        {(props.card_open && <FontAwesomeIcon icon="fa-chevron-down" className="me-2" />) || <FontAwesomeIcon icon="fa-chevron-right" className="me-2" />}
                        Benchmark Entries
                    </span>
                    
                    {/* Only show button when displaying SelectedPTC */}
                    {
                        parseInt(SelectedPTC.user_PTC_ID) > 0 && 
                        <span className="float-end">
                            <button className="btn btn-sm fw-bold col-auto border-secondary border-3 text-secondary float-end" onClick={() => setSelectedPTC({ user_PTC_ID: 0})}>
                                <FontAwesomeIcon icon="fa-arrow-left" className="me-2" />Back to Entries
                            </button>
                        </span>
                    }
                    {
                        parseInt(SelectedPTC.user_PTC_ID) === 0 && 
                        <span className="float-end">
                            {
                                BaseState.show_qr_reader === false &&
                                (
                                    (
                                        props.Action === 'benchmark_graph' &&
                                        <button className="btn btn-sm fw-bolder text-secondary border border-secondary border-3 float-end" onClick={() => handleCloseGraph()}><FontAwesomeIcon icon="fa-times" className="me-2" />Close Graph</button>
                                    ) ||
                                    <>
                                        <button className="btn btn-sm fw-bold col-auto border-primary border-3 text-primary float-end" disabled={parseInt(props.SelectedUser.user_ID) === 0} onClick={() => setBaseState({ ...BaseState, show_qr_reader: true })}>
                                            <FontAwesomeIcon icon="fa-qrcode" className="me-2" />Scan QR Code
                                        </button>
                                        <button className="btn btn-sm fw-bolder text-primary border border-primary border-3 ms-2 me-2 float-end" disabled={parseInt(props.SelectedUser.user_ID) === 0} onClick={() => props.setAction('benchmark_graph')}><FontAwesomeIcon icon="fa-chart-line" className="" /></button>
                                    </>
                                )
                            }
                            {
                                BaseState.show_qr_reader &&
                                <button className="btn btn-sm fw-bold col-auto border-primary border-3 text-primary float-end" disabled={parseInt(props.SelectedUser.user_ID) === 0} onClick={() => setBaseState({ ...BaseState, show_qr_reader: false })}>
                                    <FontAwesomeIcon icon="fa-qrcode" className="me-2" />Close Scanner
                                </button>
                            }                            
                        </span>
                    }
                </div>
                {
                    BaseState.show_qr_reader && 
                    <div className="clearfix">
                        <QRCodeComponent handleQRCode={(result) => handleQRCode(result)} />
                    </div>
                }

                {/* <span className="float-end me-2">
                    <button className="btn btn-sm fw-bold col-auto border-primary border-3 text-primary float-end" disabled={parseInt(props.SelectedUser.user_ID) === 0}>
                        <FontAwesomeIcon icon="fa-chart-line" className="me-2" />Graph
                    </button>
                </span> */}
            </div>

            {/* Conditional show the body content based on the chevron for props.card_open */}
            {
                props.card_open &&
                <div className="card-body border border-secondary border-top-0">
                    {/* Body - show benchmark entries or SelectedPTC */}
                    {
                        Benchmarks.length === 0 &&
                        (
                            (parseInt(props.SelectedUser.user_ID) === 0 && <div className="alert alert-info">Save new player details before adding benchmark entries.</div>)
                            || (parseInt(props.SelectedUser.user_ID) > 0 && <div className="alert alert-info">No Benchmark Entries Recorded</div>)
                        )
                    }
                    {
                        Benchmarks.length > 0 &&
                        SelectedPTC.user_PTC_ID === 0 &&
                        <BenchmarksListComponent Benchmarks={Benchmarks} />
                    }   

                    {/* <BenchmarksGraphComponent />              */}

                </div>
            }

            {/* Footer - display next scheduled workout */}
            <div className="card-footer text-center border border-secondary border-top-0">
                <span className="float-start"><span className="text-muted">Next Scheduled Benchmark:</span> {(Benchmarks.length === 0 && <span className="text-danger">Not Scheduled</span>) || 'Wednesday 2-28-24' }</span>
            </div>
        </div>

    )
}

// SelectedPTC display - exercise details for each workout, reps x weight with torque totals
export function BenchmarksListComponent(props) {

    let Benchmarks = [...props.Benchmarks];

    const workouts = ['supra', 'infra', 'teres', 'subscap', 'house'];
    const capitalized = ['Supra', 'Infra', 'Teres Minor', 'Subscap', 'House Combo'];

    let Balances = {
        L_max_house_balance: null,
        R_max_house_balance: null,
        L_max_infra_balance: null,
        R_max_infra_balance: null,
        L_max_subscap_balance: null,
        R_max_subscap_balance: null,
        L_max_supra_balance: null,
        R_max_supra_balance: null,
        L_max_teres_balance: null,
        R_max_teres_balance: null
    };

    // Calculate benchmark differences between last benchmark
    if ( Benchmarks.length > 0 ) {

        let LastMaxs = {
            L_max_house: null,
            R_max_house: null,
            L_max_infra: null,
            R_max_infra: null,
            L_max_subscap: null,
            R_max_subscap: null,
            L_max_supra: null,
            R_max_supra: null,
            L_max_teres: null,
            R_max_teres: null
        };

        let Comparisons = {
            L_max_house_diff: null,
            R_max_house_diff: null,
            L_max_infra_diff: null,
            R_max_infra_diff: null,
            L_max_subscap_diff: null,
            R_max_subscap_diff: null,
            L_max_supra_diff: null,
            R_max_supra_diff: null,
            L_max_teres_diff: null,
            R_max_teres_diff: null
        };

        // Get the LAST max for each exercise / side

        Benchmarks = Benchmarks.map((B, index) => {

            // For the first record, just set the temp variables for use in the next map iteration
            if ( index > 0 ) {
                for ( const [key, value] of Object.entries(Comparisons)) {
                    // console.log("Current Benchmark: ", B[`${key.replace('_diff', '')}`]);
                    // console.log("Last Benchmark: ", LastMaxs[`${key.replace('_diff', '')}`]);
                    // console.log("Subtracted: ", subtract(B[`${key.replace('_diff', '')}`], LastMaxs[`${key.replace('_diff', '')}`]));
                    // console.log("Divided: ", divide(subtract(B[`${key.replace('_diff', '')}`], LastMaxs[`${key.replace('_diff', '')}`]), LastMaxs[`${key.replace('_diff', '')}`]))
                    // console.log("Divided2: ", divide(subtract(B[`${key.replace('_diff', '')}`], LastMaxs[`${key.replace('_diff', '')}`]), B[`${key.replace('_diff', '')}`]))

                    // Only enter a calculated Comparison value if there is a new and old Max value to calculate with
                    if ( 
                        B[`${key.replace('_diff', '')}`] !== '0.0' && 
                        B[`${key.replace('_diff', '')}`] !== '0' && 
                        B[`${key.replace('_diff', '')}`] !== null &&
                        LastMaxs[`${key.replace('_diff', '')}`] !== '0.0' && 
                        LastMaxs[`${key.replace('_diff', '')}`] !== '0' && 
                        LastMaxs[`${key.replace('_diff', '')}`] !== null
                    ) {
                        // Do the percentage calculation: 100 * ( ( current max - last max ) / last max )
                        Comparisons[key] =  multiply(
                                                100,
                                                divide(
                                                    subtract(
                                                        B[`${key.replace('_diff', '')}`], 
                                                        LastMaxs[`${key.replace('_diff', '')}`]
                                                    ), 
                                                    LastMaxs[`${key.replace('_diff', '')}`]
                                                )
                                            ).toFixed(2);
                    } else {
                        // Otherwise set it to null
                        Comparisons[key] = null;
                    }
                }

            }

            // On index = 0, just set LastMax
            for ( const [key, value] of Object.entries(LastMaxs)) {
                LastMaxs[key] = B[key];
            }

            for ( const [key, value] of Object.entries(Balances)) {
                if ( 
                    B[`${key.replace('_balance', '')}`] !== '0.0' && 
                    B[`${key.replace('_balance', '')}`] !== '0' && 
                    B[`${key.replace('_balance', '')}`] !== null
                ) {                
                    // Update the Balance max to the latest one, if it was performed
                    Balances[key] = B[`${key.replace('_balance', '')}`];
                }
            }

            return { ...B, ...Comparisons}
            // Return Benchmarks record with new Comparisons key. For the first record, this object's key values will all be null
            // return B;

        });    
    }

    // Handler for displaying a percentage change between exercise benchmarks
    function DisplayPercentage(percentage) {
        if ( percentage !== null ) {
            if ( percentage > 0 ) {
                    return <span className="text-success float-end">+{percentage} %</span>
            } else if ( percentage < 0 ){
                    return <span className="text-danger float-end">{percentage} %</span>
            } else {
                if ( window.innerWidth > 1000 ) {
                    return <span className="text-muted float-end">No Change</span>
                } else {
                    return <span className="text-success float-end">0 %</span>
                }
            }
        } else {
            return false;
        }

    }

    // Calculate and display the balance difference between workouts
    function CalculateBalancePercentage(dominant, non_dominant) {
    
        if ( dominant !== '0.0' && dominant !== null && non_dominant !== '0.0' && non_dominant !== null ) {
        
            let balance = multiply(
                100,
                divide(
                    subtract(
                        dominant, 
                        non_dominant
                    ), 
                    non_dominant
                )
            ).toFixed(2);

            return DisplayPercentage(balance)
        
        } else {
            return null;
        }
    
    
    }

    // Given a workout, determine the first Benchmark value for each side
    function CalculateWorkout(w) {
        let first_dom_benchmark = null;
        let first_non_dom_benchmark = null;
        Benchmarks.forEach((PTC) => {
            if ( PTC[`R_max_${w}`] !== '0.0' && PTC[`R_max_${w}`] !== null && first_dom_benchmark === null) {
                first_dom_benchmark = PTC[`R_max_${w}`];
            }
            if ( PTC[`L_max_${w}`] !== '0.0' && PTC[`l_max_${w}`] !== null && first_non_dom_benchmark === null) {
                first_non_dom_benchmark = PTC[`L_max_${w}`];
            }
        })
        return { dom: first_dom_benchmark, non_dom: first_non_dom_benchmark }
    }

    let style_size = window.innerWidth > 1000 ? {} : {fontSize: 12+'px'};

    return (
        <div className="clearfix">

                    {workouts.map((w, index) => {
                        let FirstBenchmarks = CalculateWorkout(w);
                        console.log({FirstBenchmarks})
                        return (
                            <div className={`card ${index !== (workouts.length-1) && 'mb-4'}`} key={index}>
                                <div className="card-header">
                                    <div className={`float-start ${window.innerWidth > 1000 && 'h5'} mb-0`}>
                                        {capitalized[index]}
                                    </div>
                                    <div className="float-end">
                                        <span className="text-muted me-2">Muscle Imbalance:</span>
                                        {CalculateBalancePercentage(Balances[`R_max_${w}_balance`], Balances[`L_max_${w}_balance`])}
                                    </div>
                                </div>
                                <div className="card-body py-2">
                                    <div className="row text-muted mb-1">
                                        <span className={`${(window.innerWidth > 1000 && 'col-2') || 'col-4 pe-0'}`}><span className="border-bottom border-2">Recorded</span></span>
                                        <span className={`${(window.innerWidth > 1000 && 'col-5') || 'col-4 px-0'}`}><span className="border-bottom border-2">Dominant{ window.innerWidth > 1000 && ' Arm Max (lbs)'}</span></span>
                                        <span className={`${(window.innerWidth > 1000 && 'col-5') || 'col-4 px-0'}`}><span className="border-bottom border-2">Non-Dom{ window.innerWidth > 1000 && 'inant Arm Max (lbs)'}</span></span>
                                    </div>

                                    {/* Dominant Side Reps - stored in DB as right side */}
                                    {
                                        Benchmarks.toReversed().map((PTC, index) => {
                                            let difference_benchmark_first = 0;
                                            let diff_since_first_dom = null;
                                            let diff_since_first_non_dom = null;
                                            // Only show max line if there was actual max PTC performed
                                            if ( ( PTC[`R_max_${w}`] !== '0.0' && PTC[`R_max_${w}`] !== null ) || ( PTC[`L_max_${w}`] !== '0.0' && PTC[`L_max_${w}`] !== null ) ) {

                                                    // Calculate R / Dom side vs 1st Benchmark
                                                    if ( PTC[`R_max_${w}`] !== '0.0' && PTC[`R_max_${w}`] !== null && FirstBenchmarks.dom !== null) {
                                                        difference_benchmark_first = multiply(divide(subtract(PTC[`R_max_${w}`], FirstBenchmarks.dom), PTC[`R_max_${w}`]), 100);
                                                        if (difference_benchmark_first > 0 || difference_benchmark_first < 0) {
                                                            diff_since_first_dom = `${difference_benchmark_first.toFixed(1)}`;
                                                        }
                                                    }
                                                    // Calculate L / Non-Dom side vs 1st Benchmark
                                                    if ( PTC[`L_max_${w}`] !== '0.0' && PTC[`L_max_${w}`] !== null && FirstBenchmarks.non_dom !== null) {
                                                        difference_benchmark_first = multiply(divide(subtract(PTC[`L_max_${w}`], FirstBenchmarks.non_dom), PTC[`L_max_${w}`]), 100);
                                                        if (difference_benchmark_first > 0 || difference_benchmark_first < 0) {
                                                            diff_since_first_non_dom = `${difference_benchmark_first.toFixed(1)}`;
                                                        }
                                                    }
                                                    return (
                                                    <div className="row" key={`${w}_${PTC.user_PTC_ID}`}>
                                                        <span className={`${(window.innerWidth > 1000 && 'col-2') || 'col-4 pe-0'}`}  style={style_size}>{dayjs(PTC.date_performed).format('M-D-YY')}</span>
                                                        <span className={`${(window.innerWidth > 1000 && 'col-5') || 'col-4 px-0'}`}>
                                                            {
                                                                PTC[`R_max_${w}`] !== '0.0' && PTC[`R_max_${w}`] !== null &&
                                                                <span className="" style={style_size}>
                                                                    <span className="float-start">{PTC[`R_max_${w}`]}</span>
                                                                    <span className={`float-start ${(window.innerWidth > 1000 && 'ms-2') || 'me-3'}`}>{DisplayPercentage(PTC[`R_max_${w}_diff`])}</span>
                                                                    {
                                                                        window.innerWidth > 1000 && index < Benchmarks.length-2 &&
                                                                        <span className={`float-end ${window.innerWidth > 1000 && 'me-1'}`}>
                                                                            {DisplayPercentage(diff_since_first_dom)}
                                                                        </span>
                                                                    }
                                                                </span>
                                                            }
                                                        </span>
                                                        <span className={`${(window.innerWidth > 1000 && 'col-5') || 'col-4 px-0'}`}>
                                                            {
                                                                PTC[`L_max_${w}`] !== '0.0' && PTC[`L_max_${w}`] !== null &&
                                                                <span className="" style={style_size}>
                                                                    <span className="float-start">{PTC[`L_max_${w}`]}</span>
                                                                    <span className={`float-start ${window.innerWidth > 1000 && 'ms-2'}`}>
                                                                        {DisplayPercentage(PTC[`L_max_${w}_diff`])}
                                                                    </span>
                                                                    {
                                                                        window.innerWidth > 1000 && index < Benchmarks.length-2 &&
                                                                        <span className={`float-end ${window.innerWidth > 1000 && 'me-1'}`}>
                                                                            {DisplayPercentage(diff_since_first_non_dom)}
                                                                        </span>
                                                                    }
                                                                </span>
                                                            }
                                                        </span>                                                        
                                                    </div>
                                                )
                                            } else {
                                                return null;
                                            }
                                        })
                                    }

                                </div>

                            </div>
                        )
                    })}
        </div>
    )
}


                // // Handler for displaying a percentage change between exercise benchmarks
                // function DisplayPercentage(percentage) {
                //     if ( percentage !== null ) {
                //         if ( percentage > 0 ) {
                //             if ( window.innerWidth > 1000 ) {
                //                 return <span className="text-success float-end">+{percentage} %</span>
                //             } else {
                //                 return <span className="text-success" style={{fontSize: 12+'px'}}>+{percentage} %</span>
                //             }
                //         } else if ( percentage < 0 ){
                //             if ( window.innerWidth > 1000 ) {
                //                 return <span className="text-danger float-end">{percentage} %</span>
                //             } else {
                //                 return <span className="text-danger" style={{fontSize: 12+'px'}}>{percentage} %</span>
                //             }
                //         } else {
                //             if ( window.innerWidth > 1000 ) {
                //                 return <span className="text-muted float-end">No Change</span>
                //             } else {
                //                 return <span className="text-success" style={{fontSize: 12+'px'}}>0 %</span>
                //             }
                //         }
                //     } else {
                //         return false;
                //     }

                // }

                // // Calculate and display the balance difference between workouts
                // function CalculateBalancePercentage(dominant, non_dominant) {
                
                //     if ( dominant !== '0.0' && dominant !== null && non_dominant !== '0.0' && non_dominant !== null ) {
                    
                //         let balance = multiply(
                //             100,
                //             divide(
                //                 subtract(
                //                     dominant, 
                //                     non_dominant
                //                 ), 
                //                 non_dominant
                //             )
                //         ).toFixed(2);

                //         return DisplayPercentage(balance)
                    
                //     } else {
                //         return null;
                //     }
                
                
                // }

                // return (
                //     <div className="clearfix">

                //                 {workouts.map((w, index) => {
                //                     return (
                //                         <div className={`card ${index !== (workouts.length-1) && 'mb-4'}`} key={index}>
                //                             <div className="card-header">
                //                                 <div className={`float-start ${window.innerWidth > 1000 && 'h5'} mb-0`}>
                //                                     {capitalized[index]}
                //                                 </div>
                //                                 <div className="float-end">
                //                                     <span className="text-muted me-2">Muscle Imbalance:</span>
                //                                     {CalculateBalancePercentage(Balances[`R_max_${w}_balance`], Balances[`L_max_${w}_balance`])}
                //                                 </div>
                //                             </div>
                //                             <div className="card-body py-2">
                //                                 <div className="row text-muted mb-1">
                //                                     <span className={`${(window.innerWidth > 1000 && 'col-2') || 'col-4 pe-0'}`}><span className="border-bottom border-2">Recorded</span></span>
                //                                     <span className={`${(window.innerWidth > 1000 && 'col-5') || 'col-4 px-0'}`}><span className="border-bottom border-2">Dominant{ window.innerWidth > 1000 && ' Arm Max (lbs)'}</span></span>
                //                                     <span className={`${(window.innerWidth > 1000 && 'col-5') || 'col-4 px-0'}`}><span className="border-bottom border-2">Non-Dom{ window.innerWidth > 1000 && 'inant Arm Max (lbs)'}</span></span>
                //                                 </div>

                //                                 {/* Dominant Side Reps - stored in DB as right side */}
                //                                 {
                //                                     Benchmarks.toReversed().map((PTC) => {
                //                                         // Only show max line if there was actual max PTC performed
                //                                         if ( ( PTC[`R_max_${w}`] !== '0.0' && PTC[`R_max_${w}`] !== null ) || ( PTC[`L_max_${w}`] !== '0.0' && PTC[`L_max_${w}`] !== null ) ) {
                //                                             return (
                //                                                 <div className="row" key={`${w}_${PTC.user_PTC_ID}`}>
                //                                                     <span className={`${(window.innerWidth > 1000 && 'col-2') || 'col-4 pe-0'}`}>{dayjs(PTC.date_performed).format('M-D-YY')}</span>
                //                                                     <span className={`${(window.innerWidth > 1000 && 'col-5') || 'col-4 px-0'}`}>
                //                                                         {
                //                                                             PTC[`R_max_${w}`] !== '0.0' && PTC[`R_max_${w}`] !== null &&
                //                                                             <span className="">
                //                                                                 {PTC[`R_max_${w}`]}
                //                                                                 { window.innerWidth >= 1000 && <span className="float-end me-5">{DisplayPercentage(PTC[`L_max_${w}_diff`])}</span> }
                //                                                                 { window.innerWidth < 1000 && <span className="">{DisplayPercentage(PTC[`R_max_${w}_diff`])}</span> }
                //                                                             </span>
                //                                                         }
                //                                                     </span>
                //                                                     <span className={`${(window.innerWidth > 1000 && 'col-5') || 'col-4 px-0'}`}>
                //                                                         {
                //                                                             PTC[`L_max_${w}`] !== '0.0' && PTC[`L_max_${w}`] !== null &&
                //                                                             <span className="">
                //                                                                 {PTC[`L_max_${w}`]}
                //                                                                 { window.innerWidth >= 1000 && <span className="float-end me-5">{DisplayPercentage(PTC[`L_max_${w}_diff`])}</span> }
                //                                                                 { window.innerWidth < 1000 && <span className="">{DisplayPercentage(PTC[`L_max_${w}_diff`])}</span> }
                //                                                             </span>
                //                                                         }
                //                                                     </span>                                                        
                //                                                 </div>
                //                                             )
                //                                         } else {
                //                                             return null;
                //                                         }
                //                                     })
                //                                 }

                //                             </div>

                //                         </div>
                //                     )
                //                 })}
                //     </div>
                // )


